/**
 * Sets cookie
 * @param name
 * @param value
 * @param days
 */
export const setCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
};

/**
 * Returns cookie values
 *
 * @param name
 * @returns {string|null}
 */
export const getCookie = (name) => {
  let nameEQ = name + "=";
  let ca = document.cookie.split(';');
  for(let i=0;i < ca.length;i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
};

/**
 * Returns url hash
 *
 * @param url
 * @returns {*}
 */
export const detectHash = (url) => {
  let components = url.split('#');
  return components[1] || null;
};

/**
 * Parses date
 *
 * @param value
 * @returns {Date}
 */
export const parseDate = (value) => {

  let date = null,
      time = null;

  if (value.indexOf('.') >= 0) {
    value = value.split(' ');
    date = $.trim(value[0]);
    time = $.trim(value[1] || '');
    let parts = date.split('.');

    if (value.length === 1 && parts.length === 3) {

      // new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
      return new Date(parts[2], parts[1] - 1, parts[0]); // Note: months are 0-based

    } else if(time.length > 3 && value.indexOf(':') >= 0) {
      time = time.split(':');
      return new Date(parts[2], parts[1] - 1, parts[0], (time[0] || 0), (time[1] || 0), (time[2] || 0));

    }
  } else if (value.indexOf(':') >= 0) {
    time = $.trim(value).split(':');
    date = new Date();

    date.setHours((time[0] || 0));
    date.setMinutes((time[1] || 0));
    date.setSeconds((time[2] || 0));

    return date;
  } else {
    return new Date(value);
  }
};

export const isElementInViewport = (el) => {
  let rect = el.getBoundingClientRect();
  let fitsLeft = (rect.left >= 0 && rect.left <= $(window).width());
  let fitsTop = (rect.top >= 0 && rect.top <= $(window).height());
  let fitsRight = (rect.right >= 0 && rect.right <= $(window).width());
  let fitsBottom = (rect.bottom >= 0 && rect.bottom <= $(window).height());
  return {
    top: fitsTop,
    left: fitsLeft,
    right: fitsRight,
    bottom: fitsBottom,
    all: (fitsLeft && fitsTop && fitsRight && fitsBottom)
  };
};

/**
 * Convert seconds to human time (HH:mm)
 *
 * @param value
 * @param mode
 * @returns {string}
 */
export const toHumanTime = (value, mode = '') => {
  let secNum = parseInt(value, 10);
  let hours   = Math.floor(secNum / 3600);
  let minutes = Math.floor((secNum - (hours * 3600)) / 60);
  let seconds = secNum - (hours * 3600) - (minutes * 60);

  if (hours   < 10) {hours   = '0'+ hours;}
  if (minutes < 10) {minutes = '0'+ minutes;}
  if (seconds < 10) {seconds = '0'+ seconds;}

  if (mode === 'hh:mm') {
    return hours +':'+ minutes;
  }

  return minutes +':'+ seconds;
};

/**
 * Convert seconds to minutes
 *
 * @param value
 * @returns {number}
 */
export const toMinutes = (value) => {
  let secNum = parseInt(value, 10);
  return Math.floor(secNum / 60);
};

/**
 * Convert metres to km (if need)
 *
 * @param value
 * @returns {string}
 */
export const toHumanDistance = (value) => {
  value = parseInt(value, 10);
  let distance = value / 1000;

  if (distance < 1) return `${Math.round(value)} m`;

  return `${distance.toFixed(2)} km`;
};

/**
 * Reorders array
 * @param targetArray
 * @param indexFrom
 * @param indexTo
 * @returns {*}
 */
export const reorderArray = (targetArray, indexFrom, indexTo) => {

  let targetElement = targetArray[indexFrom];
  let magicIncrement = (indexTo - indexFrom) / Math.abs (indexTo - indexFrom);

  for (let Element = indexFrom; Element !== indexTo; Element += magicIncrement){
    targetArray[Element] = targetArray[Element + magicIncrement];
  }

  targetArray[indexTo] = targetElement;
  return targetArray;
};

/**
 * Flips array points
 * @param points
 * @returns {[]}
 */
export const flipPoints = (points) => {
  let result = [];

  for(let i = 0; i < points.length; i++) {
    result.push([
      points[i][1],
      points[i][0],
    ]);
  }
  return result;
};